// extracted by mini-css-extract-plugin
export default {"transition":"VideoRoom_transition__XOo8c"};